import { PagesID } from "@utils/utilsConfigurations";
import { CatalogEntityType } from "./types";

export const CATALOG_PAGE_ID_BY_ENTITY: Record<CatalogEntityType, PagesID> = {
  activity: PagesID["corporate.catalog.activities"],
  course: PagesID["corporate.catalog.courses"],
  path: PagesID["corporate.catalog.path"],
};

export const CATALOG_EXCLUDE_FILTER_KEYS: string[] = [
  // "id",
  // "description",
  // "detail_description",
];
